import { DOCUMENT } from '@angular/common';
import { Component, inject, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, interval } from 'rxjs';
import { ButtonDirective } from '../../components/button/button.directive';
import { TabComponent } from '../../components/tab/tab.component';
import { TabLayoutComponent } from '../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../components/table/api-table/api-table.component';
import { TableRow } from '../../components/table/table.interface';
import { CreateTicketModalComponent } from './create-ticket-modal.component';
import { TicketConversationModalComponent } from './ticket-conversation-modal.component';
import {
  createAllTimeTicketRange,
  TICKET_NUMBER_COLUMN,
} from './domain/ticket-table';

@Component({
  selector: 'app-customer-service-tab',
  standalone: true,
  imports: [
    ButtonDirective,
    TabLayoutComponent,
    APITableComponent,
    CreateTicketModalComponent,
    TicketConversationModalComponent,
  ],
  providers: [{ provide: TabComponent, useExisting: CustomerServiceTabComponent }],
  templateUrl: './customer-service-tab.component.html',
  styleUrl: './customer-service-tab.component.scss',
})
export class CustomerServiceTabComponent extends TabComponent {
  override name = this.dictionaryService.get('CustomerService');

  @ViewChild('ticketsTable') private ticketsTable?: APITableComponent;

  readonly dictionary = this.dictionaryService;
  readonly createOpen = signal(false);
  readonly selectedTicket = signal<string | null>(null);
  readonly allTimeRange = createAllTimeTicketRange();

  private readonly document = inject(DOCUMENT);
  private readonly tableRefresh = interval(30000)
    .pipe(
      filter(() => this.document.visibilityState === 'visible'),
      takeUntilDestroyed(),
    )
    .subscribe(() => this.ticketsTable?.refresh());

  override async main(): Promise<void> {}

  openTicket = (row: TableRow): void => {
    this.selectedTicket.set(String(row.value[TICKET_NUMBER_COLUMN] ?? ''));
  };

  ticketCreated(ticketNumber: string): void {
    this.createOpen.set(false);
    this.refresh();
    this.selectedTicket.set(ticketNumber);
  }

  refresh(): void {
    this.ticketsTable?.refresh();
  }

}
